module.exports = __webpack_public_path__ + "img/model.9d13c0fd.png";